import {
  allowAlerts,
  allowApiAccess,
  allowAppDirectory,
  allowDeveloperMode,
  allowResponsePlays,
  allowVisibility,
  allowChangeEvents,
  allowImpactMetrics,
  allowSchedules,
  allowServiceDirectory,
  allowEventRules,
  allowEventIntelligence,
  allowStatusPage,
  allowBISStatusPage,
  allowOperationalReviews,
  allowAnalyticsDashboards,
  allowPdLabs,
  allowReports,
  allowReportsPreview,
  allowAdvancedReports,
  allowPostmortems,
  allowExtensions,
  allowConferenceBridges,
  allowAddOns,
  allowGlobalSearch,
  allowTeams,
  allowOperationsHealth,
  allowAccountSettings,
  allowOwnerAccountSettings,
  allowAdminAccountSettings,
  allowAdminDashboard,
  allowOnCallReadiness,
  allowServiceIntelligence,
  allowForEveryone
} from './permissions.selectors';
import {
  isCurrentUserRestricted,
  isCurrentUserReadOnlyLimited
} from '../../features/fe-data/selectors';
import { LINK_IDS } from './nav-links';

export default state => ({
  isNotRestrictedAccess: !isCurrentUserRestricted(state),
  currentUserReadOnlyLimited: isCurrentUserReadOnlyLimited(state),
  // keeping these duplicate permissions keys until we get rid of the legacy nav
  alerts: allowAlerts(state),
  apiAccess: allowApiAccess(state),
  appDirectory: allowAppDirectory(state),
  developerMode: allowDeveloperMode(state),
  responsePlays: allowResponsePlays(state),
  visibility: allowVisibility(state),
  changeEvents: allowChangeEvents(state),
  impactMetrics: allowImpactMetrics(state),
  schedules: allowSchedules(state),
  serviceDirectory: allowServiceDirectory(state),
  eventRules: allowEventRules(state),
  eventIntelligence: allowEventIntelligence(state),
  statusPage: allowStatusPage(state),
  bisStatusPage: allowBISStatusPage(state),
  operationalReviews: allowOperationalReviews(state),
  analyticsDashboards: allowAnalyticsDashboards(state),
  pdLabs: allowPdLabs(state),
  reports: allowReports(state),
  reportsPreview: allowReportsPreview(state),
  advancedReports: allowAdvancedReports(state),
  postmortems: allowPostmortems(state),
  extensions: allowExtensions(state),
  conferenceBridges: allowConferenceBridges(state),
  addons: allowAddOns(state),
  globalSearch: allowGlobalSearch(state),
  teams: allowTeams(state),
  operationsHealth: allowOperationsHealth(state),
  accountSettings: allowAccountSettings(state),
  ownerAccountSettings: allowOwnerAccountSettings(state),
  adminDashboard: allowAdminDashboard(state),
  onCallReadiness: allowOnCallReadiness(state),
  serviceIntelligence: allowServiceIntelligence(state),
  // permissions based on IDs
  [LINK_IDS.INCIDENTS]: allowForEveryone(),
  [LINK_IDS.ALL_INCIDENTS]: allowForEveryone(),
  [LINK_IDS.BUSINESS_SERVICES]: allowForEveryone(),
  [LINK_IDS.MY_ON_CALL_SHIFTS]: allowForEveryone(),
  [LINK_IDS.ESCALATION_POLICIES]: allowForEveryone(),
  [LINK_IDS.PEOPLE]: allowForEveryone(),
  [LINK_IDS.USERS]: allowForEveryone(),
  [LINK_IDS.ALERTS]: allowAlerts(state),
  [LINK_IDS.RECENT_CHANGES]: allowChangeEvents(state),
  [LINK_IDS.RESPONSE_PLAYS]: allowResponsePlays(state),
  [LINK_IDS.VISIBILITY]: allowVisibility(state),
  [LINK_IDS.IMPACT_METRICS]: allowImpactMetrics(state),
  [LINK_IDS.EVENT_INTELLIGENCE]: allowEventIntelligence(state),
  [LINK_IDS.SCHEDULES]: allowSchedules(state),
  [LINK_IDS.SERVICE_DIRECTORY]: allowServiceDirectory(state),
  [LINK_IDS.SERVICES]: allowServiceDirectory(state),
  [LINK_IDS.EVENT_RULES]: allowEventRules(state),
  [LINK_IDS.OPERATIONAL_REVIEWS]: allowOperationalReviews(state),
  [LINK_IDS.INTELLIGENT_DASHBOARDS]: allowAnalyticsDashboards(state),
  [LINK_IDS.PD_LABS]: allowPdLabs(state),
  [LINK_IDS.REPORTS]: allowReports(state),
  [LINK_IDS.REPORTS_PREVIEW]: allowReportsPreview(state),
  [LINK_IDS.POSTMORTEMS]: allowPostmortems(state),
  [LINK_IDS.POSTMORTEMS_PREVIEW]: !allowPostmortems(state),
  [LINK_IDS.CONFERENCE_BRIDGES]: allowConferenceBridges(state),
  [LINK_IDS.TEAMS]: allowTeams(state),
  [LINK_IDS.OPERATIONS_HEALTH]: allowOperationsHealth(state),
  [LINK_IDS.ON_CALL_READINESS]: allowOnCallReadiness(state),
  [LINK_IDS.STATUS_DASHBOARD]: allowStatusPage(state),
  [LINK_IDS.NEW_STATUS_DASHBOARD]: allowBISStatusPage(state),
  [LINK_IDS.DEVELOPER]: allowAppDirectory(state),
  [LINK_IDS.ACCOUNT_SETTINGS_OWNER]: allowOwnerAccountSettings(state),
  [LINK_IDS.ACCOUNT_SETTINGS_ADMIN]: allowAdminAccountSettings(state),
  [LINK_IDS.ACCOUNT_SUBSCRIPTIONS]: allowOwnerAccountSettings(state),
  [LINK_IDS.API_ACCESS]: allowApiAccess(state),
  [LINK_IDS.DEVELOPER_MODE]: allowDeveloperMode(state),
  [LINK_IDS.EXTENSIONS]: allowExtensions(state),
  [LINK_IDS.ADD_ON_SETTINGS]: allowAddOns(state),
});
